import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { WrapperComponentProps } from './types.tsx';

export const PopupTriggerMenuItem = forwardRef<HTMLButtonElement, WrapperComponentProps>(
	(props, ref) => (
		<ButtonItem {...props} ref={ref} type="button" isSelected={Boolean(props['aria-expanded'])} />
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonItem = styled.button<{ isSelected: boolean }>(
	{
		backgroundColor: 'transparent',
		border: 0,
		outline: 0,
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		paddingLeft: '14px',
		marginLeft: token('space.negative.050'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) =>
		props.isSelected && {
			backgroundColor: token('elevation.surface.sunken'),
		},
);
